import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ varient?: 'small' | 'medium' }>()((
  theme,
  { varient }
) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      borderRadius: theme.spacing(1),
      background: theme.palette.text.white,
      boxSizing: 'border-box',
      padding: theme.spacing(4),
    },
    iconContainer: {
      width: varient === 'small' ? '24px' : '28px',
      height: varient === 'small' ? '24px' : '28px',
      borderRadius: theme.spacing(0.5),
      background: theme.palette.bgSecondary.main,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    header: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontWeight: 500,
      height: theme.spacing(varient === 'small' ? 3 : 3.5),
    },
    heading: {
      fontSize: varient === 'small' ? '16px' : '22px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: varient === 'small' ? '24px' : '28px',
      letterSpacing: '0.15px',
      color: theme.palette.labraText.primary,
      fontFamily: theme.typography.fontFamily,
    },
    headerTextIcon: {
      display: 'flex',
      gap: theme.spacing(1),
    },
    headerLeft: {
      display: 'flex',
      gap: theme.spacing(1.5),
      alignItems: 'center',
    },
  }
})
